"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const PlaceholderColors = {
    default: design_system_1.Colors.grey500,
    error: design_system_1.Colors.red500,
    focusedOrHovered: design_system_1.Colors.blue500,
};
exports.default = PlaceholderColors;
